






































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import {
	montarPoliticaDeTrocaPadrao,
	PLACEHOLDER_DIAS_DEVOLUCAO,
	substituirDiasDeDevolucao,
} from '@/shareds/loja-shareds'

@Component
export default class BlocoPoliticaDeTroca extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja

	get configuracao() {
		return this.loja.configuracaoDaLoja
	}

	get dicaDaPoliticaDeTroca() {
		const texto = this.configuracao.politicaDeTrocaTexto ?? ''
		if (texto.includes(PLACEHOLDER_DIAS_DEVOLUCAO)) {
			return `Substitua ${PLACEHOLDER_DIAS_DEVOLUCAO} pelo prazo de devolução em dias antes de salvar.`
		}
		return 'Impresso no cupom da NFC-e como digitado, preservando as quebras de linha. Alterar o prazo para devolução depois não atualiza este texto.'
	}

	politicaDeTrocaObrigatoria = (texto: string | null) =>
		!!texto?.trim() || 'Informe o texto da política de troca'

	semPlaceholderDeDiasDeDevolucao = (texto: string | null) => {
		const textoFinal = substituirDiasDeDevolucao(texto ?? '', this.configuracao.diasParaDevolucao ?? null)
		return (
			!textoFinal.includes(PLACEHOLDER_DIAS_DEVOLUCAO) ||
			`Substitua ${PLACEHOLDER_DIAS_DEVOLUCAO} pelo prazo de devolução em dias ou preencha "Prazo para devolução", logo acima`
		)
	}

	aoDigitarPoliticaDeTroca(texto: string) {
		this.configuracao.politicaDeTrocaTexto = substituirDiasDeDevolucao(texto, this.configuracao.diasParaDevolucao)
	}

	preencherPoliticaDeTrocaPadrao(habilitada: boolean | null) {
		if (!habilitada) return
		if (this.configuracao.politicaDeTrocaTexto?.trim()) return
		this.configuracao.politicaDeTrocaTexto = montarPoliticaDeTrocaPadrao(this.configuracao.diasParaDevolucao)
	}
}
